// extracted by mini-css-extract-plugin
module.exports = {"cards":"ProductsCardsGrid_cards_3zh-B","hasBorders":"ProductsCardsGrid_hasBorders_lIyLE","cardWrapper":"ProductsCardsGrid_cardWrapper_61Wng"};